import { BaseBus } from "./BaseBus";

export class CustomerDispatchStatistics extends BaseBus{
    constructor(data: CustomerDispatchStatistics) {
        super(data);
        this.loading = true;
   }
    initialize(data: CustomerDispatchStatistics) {
        super.initialize(data);
        this.loading = true;
    }

    dispatchesForYear?: number;
    callbacksForYear: number;
    avgTimeFRNoCallback: number;
    avgTimeFRWithCallback: number;
    avgTimeFRCallbackOnly: number;
    avgFirstAssignedPersonDate: number;
    averageFirstWorkTime: number;
    loading: boolean;
}
